import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1414fc66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex w-full h-[72px] md:h-[105px] overflow-hidden",
  style: {"background":"#fef3e7"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-feedBackAlert w-2 md:w-3" }, null, -1))
const _hoisted_3 = { class: "w-full flex justify-center items-center" }
const _hoisted_4 = {
  key: 0,
  class: "font-normal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        class: _normalizeClass(["text-feedBackAlert font-bold text-ellipsis", _ctx.mobile ? 'text-[10.5px]' : 'text-[8px] md:text-[10px]'])
      }, [
        _createTextVNode(" Vaga aberta"),
        (_ctx.detail)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " · " + _toDisplayString(_ctx.detail), 1))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}